import base, { formatNum } from 'meinian-package/src/utils/base'
import {
  getDtoConfig,
  PLATFORM_VALUE,
  ZK_PLATFORM_VALUE,
  temuPlatformIds,
  amazonPlatformIds,
  tiktokPlatformIds,
  shopeePlatformIds,
  mercadoLibrePlatformIds,
} from 'meinian-package/src/component/platformConfig'
import { getUrlLocation, getUrlParams } from '../../../../../../common/url'

const UNIT = {
  USD: '$',
  CNY: '¥',
  GBP: '£',
  AUD: 'AUD',
  BRL: 'R$',
  KWD: 'K.D.',
  AED: 'AED',
  NTD: 'NT$',
  PHP: 'PHP',
  PLN: 'zł',
  ZAR: 'R',
  SEK: 'SEK',
  SGD: 'SGD',
  EURO: '€',
  JPY: 'JPY',
  EUR: '€',
  NZD: 'NZD',
  PKR: 'PKR',
  DHS: 'DHS',
  LBP: 'LBP',
  TL: 'TL',
  MXN: 'MXN',
  SR: 'SR',
}

export enum CONFIG_KEY {
  TITLE = 'TITLE',
  PRICE = 'PRICE',
  INFO_BLOCK = 'INFO_BLOCK',
  EXTERNAL_LINK = 'EXTERNAL_LINK', // 外站链接
  CARD_INFO_BLOCK = 'CARD_INFO_BLOCK', // 卡片的信息
  ORIGIN_LINK = 'ORIGIN_LINK',
  OPTION_ITEM = 'OPTION_ITEM',
}

export const enum SOURCE_TYPE {
  DTO = 'DTO',
}

export const enum ORIGIN_LINK_TYPE {
  BLOG = '博主',
  SHOP = '店铺',
  BRAND = '品牌',
  MASTER = '达人',
  SITE = '站点',
  MARKET = '市场',
  SOURCE = '来源',
  CUSTOM = '自定义',
}

const enum INFO_BLOCK_TYPE {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
}

export const enum OPTION_ITEM_TYPE {
  DATA = 'DATA',
  TIME = 'TIME',
  DTO = 'DTO',
  CUSTOM = 'CUSTOM',
}

const fromPrice = (_val) => `¥${_val / 100}`

const cbGetRealDataSourceId = (id) => {
  // B0CC2DHPX6_colorId:53fc0b66f675289afe50cba4b3b3bd8b_104
  const lastIndex = id.lastIndexOf('_')
  if (lastIndex === -1) {
    return id
  }
  const _lastIndex = id.indexOf('_colorId:')
  if (_lastIndex === -1) {
    return id.substring(0, lastIndex)
  }
  return id.substring(0, _lastIndex)
}

const dealData = (num) => {
  return formatNum(num, 1)
}

export const ZK_DEFAULT_CONFIG = {
  [CONFIG_KEY.TITLE]: {
    labelKey: 'title',
  },
  [CONFIG_KEY.ORIGIN_LINK]: [
    {
      type: ORIGIN_LINK_TYPE.BRAND,
      labelKey: 'brand',
      linkUrl: '/df/detail/brand',
      query: {
        brand: 'brand',
      },
    },
    {
      label: '知款',
      linkUrl: (dto, item) => {
        window.open(`/df/detail/image?blogIds=${item.childEntityId}&unionIds=${item.unionId}&platformId=${dto.platformId}`)
      },
    },
  ],
  [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
}

export const ZK_CONFIG = {
  [ZK_PLATFORM_VALUE.PORTER]: {
    // NET-A-PORTER
    [CONFIG_KEY.TITLE]: {
      labelKey: 'title',
    },
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BRAND,
        labelKey: 'brand',
        linkUrl: '/df/detail/brand',
        query: {
          brand: 'brand',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [ZK_PLATFORM_VALUE.FARFETCH]: {
    // 发发奇
    [CONFIG_KEY.TITLE]: {
      labelKey: 'title',
    },
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BRAND,
        labelKey: 'brand',
        linkUrl: '/df/detail/brand',
        query: {
          brand: 'brand',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [ZK_PLATFORM_VALUE.SSENSE]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'goodsTitle',
    },
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BRAND,
        labelKey: 'brand',
        linkUrl: '/df/detail/brand',
        query: {
          brand: 'brand',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [ZK_PLATFORM_VALUE.SHOPBOP]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'title',
    },
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BRAND,
        labelKey: 'brand',
        linkUrl: '/df/detail/brand',
        query: {
          brand: 'brand',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.MUSINSA]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'title',
    },
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BRAND,
        labelKey: 'brand',
        linkUrl: '/df/detail/brand',
        query: {
          brand: 'brand',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
}

export const CONFIG = {
  [PLATFORM_VALUE.JP]: {
    // 街拍
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.SOURCE,
        labelKey: '',
        customizeFromData: (dto) => `${dto?.season}${dto.city}${dto.source}`,
        linkUrl: '/df/style',
        defaultQuery: `&platformId=${PLATFORM_VALUE.JP}`,
        query: {},
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.PINTEREST]: {
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '点赞', valueKey: 'likeNum', icon: 'm-dianzan', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '收藏', valueKey: 'collectNum', icon: 'm-shoucang', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: 'Pinterest',
        linkUrl: (dto) => {
          dto.pinUrl && window.open(dto.pinUrl)
          return dto.pinUrl
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BLOG,
        labelKey: 'nickName',
        linkUrl: '/df/detail/profiles/picture',
        defaultQuery: '&sourceType=7',
        query: {
          id: 'userId',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.INS]: {
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '点赞', valueKey: 'likeNum', icon: 'm-dianzan', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '评论', valueKey: 'commentNum', icon: 'm-pinglun', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: 'INS',
        linkUrl: (dto) => {
          window.open(dto.blogUrl)
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BLOG,
        labelKey: 'bloggerName',
        linkUrl: '/df/detail/blogger',
        defaultQuery: '&sourceType=1',
        query: {
          id: 'bloggerId',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.BRAND]: {
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BRAND,
        labelKey: 'brand',
        linkUrl: '/df/detail/brand',
        defaultQuery: '&sourceType=2',
        query: {
          brand: 'brand',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.WHOLESALE]: {
    // 批发市场
    [CONFIG_KEY.TITLE]: {
      labelKey: 'goodsTitle',
    },
    // [CONFIG_KEY.ORIGIN_LINK]: [
    //   // {
    //   //   type: ORIGIN_LINK_TYPE.MARKET,
    //   //   labelKey: 'marketName',
    //   //   // linkUrl: '/df/style',
    //   //   // defaultQuery: `&platformId=${PLATFORM_VALUE.WHOLESALE}`,
    //   //   // query: {
    //   //   //   marketName: 'marketName',
    //   //   // },
    //   // },
    //   null,
    //   {
    //     label: '知款',
    //     linkUrl: '/df/detail/image',
    //     query: {
    //       blogIds: 'childEntityId',
    //       unionIds: 'unionId',
    //       platformId: 'childPlatformId',
    //     },
    //   },
    // ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.RETAIL]: {
    // 零售市场
    [CONFIG_KEY.TITLE]: {
      labelKey: 'goodsTitle',
    },
    // [CONFIG_KEY.ORIGIN_LINK]: [
    //   // {
    //   //   type: ORIGIN_LINK_TYPE.MARKET,
    //   //   labelKey: '',
    //   //   customizeFromData: (dto) => `${dto?.season}${dto.city}${dto.column}`,
    //   //   // linkUrl: '/df/style',
    //   //   // defaultQuery: `&platformId=${PLATFORM_VALUE.RETAIL}`,
    //   //   // query: {
    //   //   //   city: 'city',
    //   //   // },
    //   // },
    //   null,
    //   {
    //     label: '知款',
    //     linkUrl: '/df/detail/image',
    //     query: {
    //       blogIds: 'childEntityId',
    //       unionIds: 'unionId',
    //       platformId: 'childPlatformId',
    //     },
    //   },
    // ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.XIAOHONGSHU]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'title',
      linkUrl: (dto, cur) => {
        window.open(`https://www.xiaohongshu.com/discovery/item/${cur.childEntityId}`)
      },
    },
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '点赞', valueKey: 'likeNum', icon: 'm-dianzan', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '收藏', valueKey: 'collectNum', icon: 'm-shoucang', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '评论', valueKey: 'commentNum', icon: 'm-pinglun', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: '小红书',
        linkUrl: (dto, cur) => {
          CONFIG[PLATFORM_VALUE.XIAOHONGSHU][CONFIG_KEY.TITLE].linkUrl(dto, cur)
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.MASTER,
        labelKey: 'bloggerName',
        linkUrl: '/df/detail/blogger',
        defaultQuery: '&sourceType=5',
        query: {
          id: 'bloggerId',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.DW]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'itemTitle',
    },
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '销量', valueKey: 'saleVolume', icon: 'm-xiaoliang', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '评价', valueKey: 'comment', icon: 'm-pingjia', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BRAND,
        labelKey: 'brand',
        linkUrl: '/df/detail/brand',
        query: {
          brand: 'brand',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '上架时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.DHH]: {
    // 订货会
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BRAND,
        labelKey: 'brand',
        linkUrl: '/df/detail/brand',
        query: {
          brand: 'brand',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.INSGOODS]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'productName',
      linkUrl: (dto) => {
        dto.productUrl && window.open(dto.productUrl)
        return dto.productUrl
      },
    },
    [CONFIG_KEY.PRICE]: [{ valueKey: 'oPriceStr' }, { valueKey: 'sPriceStr' }],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: 'INS商品',
        linkUrl: (dto, cur) => {
          CONFIG[PLATFORM_VALUE.INSGOODS][CONFIG_KEY.TITLE].linkUrl(dto, cur)
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BLOG,
        labelKey: 'bloggerName',
        linkUrl: '/df/detail/blogger',
        defaultQuery: '&sourceType=1',
        query: {
          id: 'bloggerId',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '上架时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.ITEM]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'itemTitle',
      linkUrl: (dto) => {
        window.open(`https://item.taobao.com/item.htm?id=${dto.itemId}`)
      },
    },
    [CONFIG_KEY.PRICE]: [
      { valueKey: 'price', fromData: fromPrice },
      { valueKey: 'historyMinLeftCprice', fromData: fromPrice },
    ],
    [CONFIG_KEY.CARD_INFO_BLOCK]: [
      {
        label: '月销量',
        icon: 'm-xiaoliang',
        valueKey: 'saleMonthly',
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: base.formatTaobaoVagueData.bind(base),
      },
      { label: '月收藏', icon: 'm-shoucang', valueKey: 'collectMonthly', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '评价数', icon: 'm-pingjia', valueKey: 'commentCount', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.INFO_BLOCK]: [
      {
        label: '月/总销量',
        icon: 'm-xiaoliang',
        valueKey: ['saleMonthly', 'totalSaleVolume'],
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: base.formatTaobaoVagueData.bind(base),
      },
      {
        label: '月/总收藏',
        icon: 'm-shoucang',
        valueKey: ['collectMonthly', 'collect'],
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: dealData,
      },
      { label: '评价数', icon: 'm-pingjia', valueKey: 'commentCount', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: '淘宝',
        linkUrl: (dto, cur) => {
          CONFIG[PLATFORM_VALUE.ITEM][CONFIG_KEY.TITLE].linkUrl(dto, cur)
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.SHOP,
        labelKey: 'shopName',
        linkUrl: '/shopDetail/baseInfo',
        query: {
          shopId: 'shopId',
        },
      },
      {
        label: '知衣',
        linkUrl: '/itemDetail',
        type: SOURCE_TYPE.DTO,
        query: {
          itemId: 'itemId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [
      { label: '上架时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA },
      { label: '更新时间', valueKey: 'latestUpdateTime', type: OPTION_ITEM_TYPE.TIME },
    ],
  },
  [PLATFORM_VALUE.WEIBO]: {
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '点赞', valueKey: 'likeNum', icon: 'm-dianzan', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '评论', valueKey: 'commentNum', icon: 'm-pinglun', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '转发', valueKey: 'forwardNum', icon: 'm-zhuanfa', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BLOG,
        labelKey: 'bloggerName',
        actionType: 'disabled',
        message: '该数据源已下架',
      },
      {
        message: '该数据源已下架',
        actionType: 'disabled',
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.SHOW]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'originShowTitle',
    },
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BRAND,
        labelKey: 'brand',
        linkUrl: '/df/detail/brand',
        defaultQuery: '&sourceType=2',
        query: {
          brand: 'brand',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.UPLOAD]: {
    [CONFIG_KEY.OPTION_ITEM]: [
      { label: '上传', valueKey: 'userName', type: SOURCE_TYPE.DTO },
      { label: '上传时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA },
    ],
  },
  [PLATFORM_VALUE.DY]: {
    // 只单独作为了卡片的信息展示
    [CONFIG_KEY.INFO_BLOCK]: [
      {
        label: '月浏览',
        valueKey: 'viewMonthly',
        icon: 'm-xianshi',
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: base.formatTaobaoVagueData.bind(base),
      },
      { label: '月销量', valueKey: 'saleMonthly', icon: 'm-xiaoliang', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      {
        label: '月销售额',
        valueKey: 'saleAmountMonthly',
        icon: 'm-xiaoshoue',
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: (val) => dealData(val / 100),
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '收录时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.DW_GOODS]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'itemTitle',
    },
    [CONFIG_KEY.PRICE]: [{ valueKey: 'price', fromData: fromPrice }],
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '销量', valueKey: 'saleVolume', icon: 'm-xiaoliang', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '评价', valueKey: 'comment', icon: 'm-pingjia', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BRAND,
        labelKey: 'brand',
        linkUrl: '/df/dw/detail/brand',
        query: {
          brandId: 'brandId',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/dw/detail/goods',
        query: {
          spuId: 'childEntityId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [
      { label: '上架时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA },
      { label: '更新时间', valueKey: 'updateTime', type: OPTION_ITEM_TYPE.TIME },
    ],
  },
  [PLATFORM_VALUE.DY_WORKS]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'title',
      linkUrl: (dto) => {
        dto?.videoUrl && window.open(dto?.videoUrl)
        return dto?.videoUrl
      },
    },
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '点赞', valueKey: 'likeNum', icon: 'm-xianshi', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '评论', valueKey: 'commentNum', icon: 'm-dianzan', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '转发', valueKey: 'forwardNum', icon: 'm-zhuanfa', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: '抖音作品',
        linkUrl: (dto, cur) => {
          CONFIG[PLATFORM_VALUE.DY_WORKS][CONFIG_KEY.TITLE].linkUrl(dto, cur)
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.MASTER,
        labelKey: 'streamerName',
        linkUrl: '/douyin/hostDetail',
        query: {
          hostId: 'streamerId',
        },
      },
      {
        label: '抖衣',
        linkUrl: '/douyin/videoDetail',
        query: {
          videoId: 'imageGroupEntityId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.XIU_CHANGE_XI_JIE]: {
    [CONFIG_KEY.TITLE]: {
      customizeFromData: (dto) =>
        `${dto.runwayDataDTO.brand}${dto.runwayDataDTO.season}${dto.runwayDataDTO.city}${dto.runwayDataDTO.columnName}${dto.contentType}`,
    },
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BRAND,
        labelKey: '',
        customizeFromData: (dto) => `${dto?.runwayDataDTO.brand}`,
        linkUrl: (dto) => {
          window.open(`/df/detail/brand?sourceType=2&brand=${dto.runwayDataDTO.brand}`)
        },
        query: {},
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.SHI_ZHUANG_DA_PIAN]: {
    [CONFIG_KEY.TITLE]: {
      customizeFromData: (dto) => `${dto.brand}${dto.season}${dto.columnName}`,
    },
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        customizeTypeKey: 'columnName',
        customizeFromData: (dto) => {
          if (dto?.columnName === '杂志' || dto?.columnName === '杂志大片') {
            return `${dto?.magazineName}${dto?.season}`
          }
          return `${dto?.brand}${dto?.season}`
        },
        linkUrl: (dto) => {
          const urls = {
            搭配手册: `/df/detail/blockbuster?id=${dto.articleId}`,
            广告大片: `/df/detail/blockbuster?id=${dto.articleId}`,
            杂志: `/df/detail/mag-book?id=${dto.articleId}&season=${dto?.season}`,
            杂志大片: `/df/detail/mag-book?id=${dto.articleId}&season=${dto?.season}`,
          }
          if (urls?.[dto.columnName]) {
            window.open(urls[dto.columnName])
          }
          return false
        },
        query: {
          brand: 'brand',
        },
      },
      {
        label: '知款',
        linkUrl: '/df/detail/image',
        query: {
          blogIds: 'childEntityId',
          unionIds: 'unionId',
          platformId: 'childPlatformId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.ZHI_XIAO_HONG]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'title',
      linkUrl: (dto) => {
        window.open(`https://www.xiaohongshu.com/discovery/item/${dto.noteId}`)
      },
    },
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '点赞', valueKey: 'likeNum', icon: 'm-dianzan', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '收藏', valueKey: 'collectNum', icon: 'm-shoucang', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '评论', valueKey: 'commentNum', icon: 'm-pinglun', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BLOG,
        labelKey: 'nickname',
        linkUrl: (dto) => {
          window.open(`/xhs/up/overview?id=${dto.xhsUserId}`)
        },
      },
      {
        label: '知小红',
        type: SOURCE_TYPE.DTO,
        linkUrl: '/xhs/note',
        query: {
          noteId: 'noteId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.ZXH_ITEM]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'itemTitle',
    },
    [CONFIG_KEY.PRICE]: [{ valueKey: 'disPrice', fromData: fromPrice }],
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '销量', valueKey: 'saleVolume', icon: 'm-xiaoliang', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      {
        label: '销售额',
        valueKey: 'saleAmount',
        icon: 'm-xiaoshoue',
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: (val) => dealData(val / 100),
      },
      { label: '评价', valueKey: 'commentNum', icon: 'm-pingjia', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: '小红书商品',
        linkUrl: (dto) => window.open(`https://www.xiaohongshu.com/goods-detail/${dto?.itemId}`),
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      null,
      {
        label: '知小红',
        type: SOURCE_TYPE.DTO,
        linkUrl: '/xhs/item',
        query: {
          id: 'itemId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '收录时间', valueKey: 'recordTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.CROSSBORDER]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'itemName',
      linkUrl: (dto) => {
        dto?.itemSiteUrl && window.open(dto?.itemSiteUrl)
        return dto?.itemSiteUrl
      },
    },
    [CONFIG_KEY.PRICE]: [
      {
        valueKey: 'sprice',
        fromData: (val, dto) => {
          return `${UNIT?.[dto.currency] || dto?.currency}${val / 100}`
        },
      },
    ],
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '月销量', valueKey: 'saleVolumeMonthly', icon: 'm-xiaoliang', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '评价数', valueKey: 'itemEvaluate', icon: 'm-pingjia', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.SITE,
        labelKey: '',
        customizeFromData: (dto) => {
          const _platformId = String(dto.platformId).substring(1)
          if (_platformId === '09') {
            return dto?.shopInfo?.shopName || ''
          }
          return dto?.siteName
        },
        linkUrl: async (dto) => {
          const _platformId = Number(String(dto.platformId).substring(1))
          const platformUrls = {
            822: '/cross-border/ozon',
            3697: '/cross-border/walmart',
            67: '/cross-border/aliexpress',
            9: (dto) => `/cross-border/shop-detail/goods?platformType=09&shopId=${dto?.shopInfo?.shopId}`,
          }
          if (amazonPlatformIds.includes(_platformId)) {
            const url = `/cross-border/amazon/goods-repository?platformType=${_platformId}`
            window.open(url)
            return
          }
          if (tiktokPlatformIds.includes(_platformId)) {
            const url = `/cross-border/tiktok-shop/goods-repository?platformType=${_platformId}`
            window.open(url)
            return
          }
          if (temuPlatformIds.includes(_platformId)) {
            const url = `/cross-border/temu/goods?platformType=${_platformId}`
            window.open(url)
            return
          }
          if (shopeePlatformIds.includes(_platformId)) {
            const url = `/cross-border/shopee/goods?platformType=${_platformId}`
            window.open(url)
            return
          }
          if (mercadoLibrePlatformIds.includes(_platformId)) {
            const url = `/cross-border/mercado-libre/goods?platformType=${_platformId}`
            window.open(url)
            return
          }
          const url = platformUrls[_platformId] || `/cross-border/site-detail/goods?platformType=${_platformId}`
          window.open(typeof url === 'function' ? url(dto) : url)
        },
        query: {},
      },
      {
        label: '海外探款',
        linkUrl: (dto) => {
          const _platformId = Number(String(dto.platformId).substring(1))
          const urlMap: { [key: number]: string } = {
            822: '/cross-border/ozon/skc-detail/color',
            3697: '/cross-border/walmart',
            67: '/cross-border/aliexpress',
          }
          if (amazonPlatformIds.includes(_platformId)) {
            const url = `/cross-border/amazon/goods-detail/info?platformType=${_platformId}&productId=${dto.productId}`
            window.open(url)
            return
          }
          if (tiktokPlatformIds.includes(_platformId)) {
            const url = `/cross-border/tiktok-shop/goods-detail/info?platformType=${_platformId}&productId=${dto.productId}`
            window.open(url)
            return
          }
          if (temuPlatformIds.includes(_platformId)) {
            const url = `/cross-border/temu/goods-detail/info?platformType=${_platformId}&productId=${dto.productId}`
            window.open(url)
            return
          }
          if (shopeePlatformIds.includes(_platformId)) {
            const url = `/cross-border/shopee/goods-detail/info?platformType=${_platformId}&productId=${dto.productId}`
            window.open(url)
            return
          }
          if (mercadoLibrePlatformIds.includes(_platformId)) {
            const url = `/cross-border/mercado-libre/goods-detail/info?platformType=${_platformId}&productId=${dto.productId}`
            window.open(url)
            return
          }
          if (_platformId in urlMap) {
            const baseUrl = urlMap[_platformId]
            if (_platformId === 822) {
              const urlParams = getUrlParams(dto.itemDetailUrl)
              window.open(
                `${baseUrl}?platformType=${urlParams.platformType}&productId=${urlParams.productId}&colorId=${urlParams.productId}`
              )
            } else {
              window.open(`${baseUrl}${dto.itemDetailUrl}`)
            }
          } else {
            window.open(`/cross-border${dto.itemDetailUrl}`)
          }
        },
        query: {},
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [
      { label: '上架时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA },
      { label: '更新时间', valueKey: 'itemUpdateTime', type: OPTION_ITEM_TYPE.TIME },
    ],
  },
  [PLATFORM_VALUE.CROSSBORDER_INS]: {
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '点赞', valueKey: 'likeNum', icon: 'm-dianzan', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '评论', valueKey: 'commentNum', icon: 'm-pinglun', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: '海外探款INS款式',
        linkUrl: (dto) => {
          window.open(dto.blogUrl)
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BLOG,
        labelKey: 'bloggerName',
        linkUrl: '/cross-border/streamer-detail/info',
        query: {
          bloggerId: 'bloggerId',
        },
      },
      {
        label: '海外探款',
        linkUrl: (dto, cur) => {
          const id = cbGetRealDataSourceId(cur.childEntityId)
          window.open(`/cross-border/ins-detail/info?id=${id}&type=blog`)
        },
        query: {},
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.CROSSBORDER_INS_GOODS]: {
    [CONFIG_KEY.TITLE]: {
      customizeFromData: (dto) => `${dto.bloggerObj.nickName}`,
      linkUrl: (dto) => {
        dto?.productUrl && window.open(dto?.productUrl)
        return dto?.productUrl
      },
    },
    [CONFIG_KEY.PRICE]: [{ valueKey: 'oPriceStr' }, { valueKey: 'sPriceStr' }],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: '海外探款INS商品',
        linkUrl: (dto, cur) => {
          CONFIG[PLATFORM_VALUE.CROSSBORDER_INS_GOODS][CONFIG_KEY.TITLE].linkUrl(dto, cur)
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.BLOG,
        labelKey: 'bloggerName',
        linkUrl: '/cross-border/streamer-detail/info',
        query: {
          bloggerId: 'bloggerId',
        },
      },
      {
        label: '海外探款',
        linkUrl: (dto, cur) => {
          const id = cbGetRealDataSourceId(cur.childEntityId)
          window.open(`/cross-border/ins-detail/info?id=${id}&type=item`)
        },
        query: {},
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.CROSSBORDER_SHOW]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'originShowTitle',
    },
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.SITE,
        labelKey: 'brand',
        actionType: 'disabled',
        message: '该数据源已下架',
      },
      {
        label: '海外探款',
        message: '该数据源已下架',
        actionType: 'disabled',
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.CROSSBORDER_PINTEREST]: {
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '点赞', valueKey: 'likeNum', icon: 'm-dianzan', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '收藏', valueKey: 'collectNum', icon: 'm-shoucang', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: 'Pinterest',
        linkUrl: (dto) => {
          dto.jumpUrl && window.open(dto.jumpUrl)
          return dto.jumpUrl
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.MASTER,
        labelKey: 'nickName',
        linkUrl: (dto) => {
          window.open(`/cross-border/pinterest-streamer-detail/pins?pinterestUserId=${dto.userId}`)
        },
      },
      {
        label: '海外探款',
        linkUrl: (dto, cur) => {
          const id = cbGetRealDataSourceId(cur.childEntityId)
          window.open(`/cross-border/pin-detail/info?pinnerId=${dto.userId}&pinId=${id}`)
        },
        query: {},
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.CROSSBORDER_TIKTOK]: {
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '点赞', valueKey: 'likeNum', icon: 'm-dianzan', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      { label: '评论', valueKey: 'commentCount', icon: 'm-pinglun', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
    ],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: 'Tiktok',
        linkUrl: (dto) => {
          dto.tiktokUrl && window.open(dto.tiktokUrl)
          return dto.tiktokUrl
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.MASTER,
        labelKey: 'userName',
        linkUrl: (dto) => {
          window.open(`/cross-border/tiktok-streamer-detail/video?bloggerId=${dto.userId}`)
        },
      },
      {
        label: '海外探款',
        linkUrl: (dto) => {
          window.open(`/cross-border/tiktok-detail/info?videoId=${dto.sourceBlogId}`)
        },
        query: {},
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.CROSSBORDER_PATTERN]: {
    [CONFIG_KEY.ORIGIN_LINK]: [
      null,
      {
        label: '海外探款',
        linkUrl: (dto) => {
          window.open(`/cross-border/pattern-detail?id=${dto.imageGroupEntityId}&type=${dto?.sourceType?.[0]}`)
        },
        query: {},
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '发布时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.TAOBAO_ZHI_DA]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'collocationTitle',
    },
    [CONFIG_KEY.PRICE]: [
      { valueKey: 'cprice', fromData: fromPrice },
      { valueKey: 'couponCprice', label: '预估到手价：', fromData: fromPrice },
    ],
    [CONFIG_KEY.INFO_BLOCK]: [
      { label: '总销量', valueKey: 'salesVolume', icon: 'm-xiaoliang', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      {
        label: '总销售额',
        valueKey: 'salesAmount',
        icon: 'm-xiaoshoue',
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: (val) => dealData(val / 100),
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.SHOP,
        labelKey: 'shopName',
        linkUrl: '/shopDetail/baseInfo',
        query: {
          shopId: 'shopId',
        },
      },
      {
        label: '知衣',
        linkUrl: '/ootdDetail',
        type: SOURCE_TYPE.DTO,
        query: {
          collocationId: 'collocationId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '上架时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.COLLECT_PLUG]: {
    // 采集插件
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        labelKey: 'originWeb',
        linkUrl: (dto) => {
          const curLocation = getUrlLocation(dto.originUrl)
          curLocation && window.open(`${curLocation.origin}`)
        },
      },
      {
        label: '去原文链接',
        linkUrl: (dto) => {
          window.open(dto.originUrl)
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '采集时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.FD_PLUS]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'title',
    },
    [CONFIG_KEY.ORIGIN_LINK]: [
      null,
      {
        label: '作品详情',
        linkUrl: (dto) => {
          window.open(dto.originUrl)
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [{ label: '生成时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA }],
  },
  [PLATFORM_VALUE.FD_MATERIAL]: {
    [CONFIG_KEY.TITLE]: {
      labelKey: 'brief',
    },
    [CONFIG_KEY.OPTION_ITEM]: [
      {
        label: '素材类型',
        valueKey: 'materialType',
        type: OPTION_ITEM_TYPE.CUSTOM,
        fromData: (dto) => (dto?.materialType === 1 ? '模特' : '面料'),
      },
      {
        labelKey: 'featureNameF',
        valueKey: 'featureF',
        type: OPTION_ITEM_TYPE.CUSTOM,
      },
      {
        labelKey: 'featureNameS',
        valueKey: 'featureS',
        type: OPTION_ITEM_TYPE.CUSTOM,
      },
      { label: '生成时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA },
    ],
  },
}

export const DY_CONFIG = [
  {
    // 达人
    [CONFIG_KEY.TITLE]: {
      labelKey: 'itemTitle',
      linkUrl: (dto, cur) => {
        window.open(
          `https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?h5_origin_type=detail_share&id=${cur?.imageGroupEntityId}`
        )
      },
    },
    [CONFIG_KEY.PRICE]: [
      { valueKey: 'price', fromData: fromPrice },
      { valueKey: 'minPrice', fromData: fromPrice },
    ],
    [CONFIG_KEY.INFO_BLOCK]: [
      {
        label: '月/总销量',
        valueKey: ['saleMonthly', 'saleVolume'],
        icon: 'm-xiaoliang',
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: dealData,
      },
      {
        label: '月/总销售额',
        valueKey: ['saleAmountMonthly', 'saleAmount'],
        icon: 'm-xiaoshoue',
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: (val) => dealData(val / 100),
      },
    ],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: '抖音达人',
        linkUrl: (dto, cur) => {
          DY_CONFIG[0][CONFIG_KEY.TITLE].linkUrl(dto, cur)
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.MASTER,
        labelKey: 'relateStreamerName',
        linkUrl: '/douyin/hostDetail',
        query: {
          hostId: 'hostId',
        },
      },
      {
        label: '抖衣',
        linkUrl: '/douyin/itemDetail/info',
        query: {
          itemId: 'imageGroupEntityId',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [
      { label: '收录时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA },
      { label: '更新时间', valueKey: 'latestUpdateTime', type: OPTION_ITEM_TYPE.TIME },
    ],
  },
  {
    // 小店
    [CONFIG_KEY.TITLE]: {
      labelKey: 'itemTitle',
      linkUrl: (dto, cur) => {
        window.open(
          `https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?h5_origin_type=detail_share&id=${cur?.imageGroupEntityId}`
        )
      },
    },
    [CONFIG_KEY.PRICE]: [
      { valueKey: 'price', fromData: fromPrice },
      { valueKey: 'minPrice', fromData: fromPrice },
    ],
    [CONFIG_KEY.CARD_INFO_BLOCK]: [
      { label: '月销量', valueKey: 'saleMonthly', icon: 'm-xiaoliang', type: INFO_BLOCK_TYPE.SINGLE, fromData: dealData },
      {
        label: '月销售额',
        valueKey: 'saleAmountMonthly',
        icon: 'm-xiaoshoue',
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: (val) => dealData(val / 100),
      },
    ],
    [CONFIG_KEY.INFO_BLOCK]: [
      {
        label: '月/总销量',
        valueKey: ['saleMonthly', 'saleVolume'],
        icon: 'm-xiaoliang',
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: dealData,
      },
      {
        label: '月/总销售额',
        valueKey: ['saleAmountMonthly', 'saleAmount'],
        icon: 'm-xiaoshoue',
        type: INFO_BLOCK_TYPE.SINGLE,
        fromData: (val) => dealData(val / 100),
      },
    ],
    [CONFIG_KEY.EXTERNAL_LINK]: [
      {
        label: '抖音店铺',
        linkUrl: (dto, cur) => {
          DY_CONFIG[1][CONFIG_KEY.TITLE].linkUrl(dto, cur)
        },
      },
    ],
    [CONFIG_KEY.ORIGIN_LINK]: [
      {
        type: ORIGIN_LINK_TYPE.SHOP,
        labelKey: 'shopName',
        linkUrl: '/douyin/shopDetail',
        query: {
          shopId: 'shopId',
        },
      },
      {
        label: '抖衣',
        linkUrl: '/itemDetail/douyin/info',
        type: SOURCE_TYPE.DTO,
        query: {
          itemId: 'itemIdString',
        },
      },
    ],
    [CONFIG_KEY.OPTION_ITEM]: [
      { label: '收录时间', valueKey: 'sourceTime', type: OPTION_ITEM_TYPE.DATA },
      { label: '更新时间', valueKey: 'latestUpdateTime', type: OPTION_ITEM_TYPE.TIME },
    ],
  },
]

export const getPlatformConfig = (platformId: string | number, isFromZkPlatform: boolean) => {
  const dotConfig = getDtoConfig(platformId, isFromZkPlatform)
  if (isFromZkPlatform) {
    return {
      config: ZK_CONFIG?.[Number(platformId)] || ZK_DEFAULT_CONFIG,
      dtoConfig: dotConfig,
    }
  }
  return {
    config: CONFIG?.[Number(platformId)] || {},
    dtoConfig: dotConfig,
  }
}
